import { v4 as uuid } from 'uuid';

import { SummitFormattedText } from '@summit/models';

import { assignSafe } from '@summit/core';
import { State } from './state/state';

export class Address {
  id: string;
  name: string;
  line1: string;
  line2: string;
  city: string;
  stateID: string;
  state: State;
  country: string;
  zipOrPostalCode: string;

  constructor(jsonData?: Partial<Address>) {
    if (jsonData) {
      assignSafe(this, jsonData);
      if (jsonData.state) {
        this.state = new State(jsonData.state);
      }
    }
    if (!this.id) this.id = uuid();
    // console.log(`Created ${JSON.stringify(this, null, 2)} from ${JSON.stringify(jsonData, null, 2)}`)
  }

  static FreeformAddress(address: Address): string {
    return address.toString();
  }

  isEmpty(): boolean {
    const response =
      (!this.name || this.name.length === 0) &&
      (!this.line1 || this.line1.length === 0) &&
      (!this.line2 || this.line2.length === 0) &&
      (!this.city || this.city.length === 0) &&
      (!this.stateID || this.stateID.length === 0) &&
      (!this.country || this.country.length === 0) &&
      (!this.zipOrPostalCode || this.zipOrPostalCode.length === 0);
    // console.log(`Current address: ${JSON.stringify(this, null, 2)} is blank = ${response}`);
    return response;
  }

  get ToSortString(): string {
    const stateString = this.state && this.state.abbreviation ? this.state.abbreviation : 'Unk';
    return `${stateString} ${this.city} ${this.zipOrPostalCode} ${this.line1} ${this.line2}`;
  }

  public ToString(): string {
    let response = '';
    if (this.line1) {
      response += this.line1;
    }
    if (this.line2) {
      if (response.length > 0) {
        response += ', ';
      }
      response += this.line2;
    }
    if (this.city) {
      if (response.length > 0) {
        response += ', ';
      }
      response += this.city;
    }
    if (this.state && this.state.abbreviation) {
      if (response.length > 0) {
        response += ', ';
      }
      response += this.state.abbreviation;
    }
    if (this.zipOrPostalCode) {
      if (response.length > 0) {
        response += ' ';
      }
      response += this.zipOrPostalCode;
    }
    return response;
  }

  public ToMailingFormat(): SummitFormattedText {
    const response = new SummitFormattedText();
    if (this.line1) response.AddLine(this.line1);
    if (this.line2) response.AddLine(this.line2);
    let cityLine = '';
    if (this.city) cityLine += this.city;
    if (cityLine.length > 0 && this.stateID) cityLine += ', ';
    if (this.state) cityLine += this.state.abbreviation;
    if (cityLine.length > 0 && this.zipOrPostalCode) cityLine += ' ';
    if (this.zipOrPostalCode) cityLine += this.zipOrPostalCode;
    if (cityLine.length > 0) response.AddLine(cityLine);
    return response;
  }

  public isValid(): boolean {
    return this.line1 && this.city && this.stateID && this.zipOrPostalCode ? true : false;
  }
}
